import CommonChatContainer from "./CommonChatContainer";
import { useState } from "react";
import { CHAT_WRITE_MESSAGE_HERE } from "../../i18n/keysTranslations";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import "../../assets/css/chat.css";

const CommonChatMainContainer = ({
  onChangeShowChat = () => {},
  showSendFileButton,
  chatConfigurationID,
  chatContext,
  globalReportContext,
  agentFlow,
  context = null,
  startMode = "all",
  placeholderInput = CHAT_WRITE_MESSAGE_HERE,
  headerTitle = CHAT_WRITE_MESSAGE_HERE,
  statisticsView = true,
  onCallbackApplyOptimization = () => {},
  onCallbackChangeOptimizations = () => {},
  onRegisterClearPreloadedMessages = () => {},
  embedded = false,
  // Rediseño
  showOnlyMessages = false,
  hideLauncher = false,
  controlledOpen,
  onChangeOpen,
  exposeSendMessage,
  exposeChatActions,
  preloadedMessages = {},
  isLoadingMessages = false,
  hasMoreMessages = false,
  onLoadOlderMessages,
  sx,
  exposeMessageCount,
  onAgentReply,
  showPreviewOptimization = true,
  contentSx,
  showMinimize = true,
  showHeader = true,
  welcomeCenteredSingleColumn = false,
  optimizationsSingleColumn = false,
  demoMode = false,
  demoBotReply,
  disabledInteractions = false,
  messageVariant,
}) => {
  const [mode, setMode] = useState(startMode);
  return (
    <CommonChatContainer
      onChangeShowChat={onChangeShowChat}
      showSendFileButton={showSendFileButton}
      chatConfigurationID={chatConfigurationID}
      chatContext={chatContext}
      globalReportContext={globalReportContext}
      agentFlow={agentFlow}
      context={context}
      mode={mode}
      onChangeMode={(mode) => setMode(mode)}
      placeholderInput={placeholderInput}
      headerTitle={headerTitle}
      statisticsView={statisticsView}
      onCallbackApplyOptimization={onCallbackApplyOptimization}
      onCallbackChangeOptimizations={onCallbackChangeOptimizations}
      onRegisterClearPreloadedMessages={onRegisterClearPreloadedMessages}
      embedded={embedded}
      showOnlyMessages={showOnlyMessages}
      hideLauncher={hideLauncher}
      controlledOpen={controlledOpen}
      onChangeOpen={onChangeOpen}
      exposeSendMessage={exposeSendMessage}
      exposeChatActions={exposeChatActions}
      preloadedMessages={preloadedMessages}
      isLoadingMessages={isLoadingMessages}
      hasMoreMessages={hasMoreMessages}
      onLoadOlderMessages={onLoadOlderMessages}
      onAgentReply={onAgentReply}
      sx={sx}
      contentSx={contentSx}
      showMinimize={showMinimize}
      showHeader={showHeader}
      welcomeCenteredSingleColumn={welcomeCenteredSingleColumn}
      optimizationsSingleColumn={optimizationsSingleColumn}
      demoMode={demoMode}
      demoBotReply={demoBotReply}
      exposeMessageCount={exposeMessageCount}
      showPreviewOptimization={showPreviewOptimization}
      disabledInteractions={disabledInteractions}
      messageVariant={messageVariant}
    />
  );
};

export default CommonChatMainContainer;
